module.exports = __webpack_public_path__ + "img/img6.be05cb37.svg";